import { GetStaticProps, GetStaticPaths } from 'next';
import { getAllPostSlugs, getRedirectPaths } from '@api';
import { PostPage } from '@components';
import { getStaticPropsCore } from '@/src/getStatic/getStaticPropsCore';

export const getStaticProps = async ({
  params,
}: Parameters<GetStaticProps<any, { slug: string }>>[0]) => {
  console.info(`getStaticProps /blog/${params?.slug}`);
  return await getStaticPropsCore(params?.slug || '', {
    redirectionReferencePath: `/knowledge/blog/${params?.slug}/`,
  });
};

export const getStaticPaths: GetStaticPaths = async () => {
  const redirects = await getRedirectPaths();

  return {
    paths: (await getAllPostSlugs({ where: { categoryNotIn: ['356'] } }))
      .map((slug) => `/knowledge/blog/${slug}`)
      .filter((path) => !redirects.has(`${path}/`)),
    fallback: 'blocking',
  };
};

export default PostPage;
